import React, { Component } from 'react';

import { connect } from 'react-redux';

import * as Catalogs from 'catalogs/components';
import CatalogFormHandlers from 'catalogs/containers/CatalogFormHandlers';

import { getIsSaving, getIsFetching, getEditing, getIsFetchingConfig } from 'catalogs/selectors';
import { getCompany, getSubcompany } from 'auth/selectors';

class CatalogsFormContainer extends Component {
  render = () => (
    <CatalogFormHandlers
      render={({
        isSubmitted,
        isSaving,
        handleValueChange,
        handleValidation,
        handleSubmit,
        handleRemoveElement,
        handleAddElement,
      }) => (
        <Catalogs.FormView
          subcompany={this.props.subcompany}
          isSubmitted={isSubmitted}
          isSaving={isSaving}
          isFetching={this.props.isFetching}
          handleValueChange={handleValueChange}
          handleValidation={handleValidation}
          handleSubmit={handleSubmit}
          handleRemoveElement={handleRemoveElement}
          handleAddElement={handleAddElement}
          company={this.props.company}
          catalog={this.props.catalog}
        />
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getIsSaving(state),
  isFetching: getIsFetching(state),
  isFetchingConfig: getIsFetchingConfig(state),
  catalog: getEditing(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(CatalogsFormContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/containers/CatalogsFormContainer.js